import { getCouponBannerConfig, setCouponBannerConfig } from '@/lib/api-client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTenant } from './use-tenant';
import { CouponBannerDto } from '@/lib/dtos';

export function useGetCouponBanner() {
  const tenant = useTenant();

  return useQuery<CouponBannerDto | null, Error>({
    queryKey: ['coupon-banner', tenant.slug],
    queryFn: () => {
      if (!tenant.slug) {
        return Promise.reject(new Error('Tenant slug is not available'));
      }
      return getCouponBannerConfig(tenant.slug);
    },
    enabled: !!tenant.slug,
  });
}

export function useSetCouponBanner() {
  const tenant = useTenant();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CouponBannerDto) => {
      if (!tenant.slug) {
        return Promise.reject(new Error('Tenant slug is not available'));
      }
      return setCouponBannerConfig(tenant.slug, payload);
    },
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['coupon-banner', tenant.slug],
      }),
  });
}
